import React, { useEffect, useState } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { getRecommendations } from "../../../services/webService";
import { Colors } from "../../../static/static";
import "./recommendations.css";

function Recommendations() {
  const [recommendations, setRecommendations] = useState([])

  useEffect(() =>{
    const fetchRecommendations = async() =>{
      try{
        const recommendationsVideos = await getRecommendations();
        setRecommendations(recommendationsVideos);
      } catch(error){
        console.error('Error fetching recommendations videos');
      }
    }
    fetchRecommendations();
  }, [])

  return (
    <Box className="recommendations-container" pt={16} pb={16}
    bg={Colors.bgBrown}
    zIndex="-1">
    <Flex
      justifyContent="center" 
      alignItems="center" 
      height="100%" 
      mb={4}
    >
      <Text fontSize={{base: "3xl", xl: "5dvh"}} color={Colors.heading} fontWeight={600}>
        התלמידים שלנו ממליצים:
      </Text>
    </Flex>
      <Flex
        justify="center"
        align="center"
        wrap="wrap"
        gap={{ base: "5", md: "100", lg: "10", xl: "100" }}
      >
        {recommendations.map((recommendation) => (
          <Box
            key={recommendation.id}
            borderWidth={1}
            borderRadius="lg"
            overflow="hidden"
            boxShadow="lg"
            width="50dvh"
            height="auto"
            display="flex"
            flexDirection="column"
            alignItems="center"
            mb={0}
            zIndex={1}
          >
            <Box width="100%" height={{ base: "20dvh", md: "35dvh" }}>
              <iframe
                width="100%"
                height="100%"
                src={recommendation.url}
                title={`Video player: ${recommendation.title}`}                
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </Box>
          </Box>
        ))}
      </Flex>
    </Box>
  );
}

export default Recommendations;
